import React, { useState } from 'react';
import { PRO_IMAGES } from './getBlobImages';
import { DescriptionOutlined } from '@material-ui/icons';
import ImageMetaData from '../../../../../common/ProImages/components/Popup/components/ImageMetaData';
import StyledToolTip from '../../../../../common/StyledToolTip';
import { CircularProgress } from '@material-ui/core';
import { postData } from '../../../../../../api/componentAPIs';
import { withSnackbar } from 'notistack';

const getEDRList = (eDRs, imageURLDetailsByTimestamp) => {
  return eDRs
    .map(({ key, blobData }) => ({
      key,
      blobData,
      ...imageURLDetailsByTimestamp[key]
    }))
    .sort((x, y) => y.key - x.key);
};

const EDRList = ({
  eDRData,
  showImages,
  classes,
  openEDR,
  enablePublishDeliveryReceiptFromReport,
  imageURLDetailsByTimestamp,
  proReceiverDetails,
  enqueueSnackbar
}) => {
  const [sendEDRLoader, setSendEDRLoader] = useState(null);
  const eDRList = getEDRList(eDRData[showImages].eDR, imageURLDetailsByTimestamp);
  const sendEDR = (e, eDR) => {
    e.stopPropagation();
    setSendEDRLoader(eDR.file);
    const data = {
      terminalCode: proReceiverDetails.terminalCode,
      routeId: proReceiverDetails.routeId,
      proNumber: `${eDR.file}`, //proNumber with all suffixes attached to file name
      receiverName: proReceiverDetails?.name || null,
      receiverPhoneNumber: proReceiverDetails?.contact || null, //optional
      receiverEmail: proReceiverDetails?.email || null //optional
    };
    postData('PublishDeliveryReceipt', data).then(
      (response) => {
        if (response && response.status >= 200 && response.status < 400) {
          setSendEDRLoader(null);
          enqueueSnackbar('Delivery receipt published successfully', {
            variant: 'success'
          });
        } else {
          handleSendEDRError(response);
        }
      },
      () => {
        handleSendEDRError();
      }
    );
  };

  const handleSendEDRError = (response) => {
    setSendEDRLoader(null);
    if (response?.statusCode === 403) {
      return;
    }
    const errorMessage = response?.response?.data?.error?.message || response?.message;    
    enqueueSnackbar(
      errorMessage ||
        'An error occurred while publishing delivery receipt. Please try again later.',
      { variant: 'error' }
    );
  };
  return (
    <>
      <div className={classes.label}>{PRO_IMAGES.edr}</div>
      <div className={classes.edrContainer}>
        {eDRList.map((eDR, index) => (
          <div className={classes.edRBox}>
            <ImageMetaData
              key={eDR?.timestamp ?? index}
              date={eDR?.date}
              time={eDR?.time}
              address={eDR?.address}
              isEDR={true}>
              <div
                className={classes.eDRPlaceholderContainer}
                onClick={() => openEDR(eDR)}>
                {enablePublishDeliveryReceiptFromReport && proReceiverDetails && (
                  <div className={classes.edrActions}>
                    {sendEDRLoader === eDR.file ? (
                      <CircularProgress size={16} classes={{ root: classes.circularProgress }} />
                    ) : (
                      <StyledToolTip title="Send e-DR to AS400">
                        <i
                          className={`${classes.actionIcon} icon-icon_upload`}
                          onClick={(e) => sendEDR(e, eDR)}
                        />
                      </StyledToolTip>
                    )}
                  </div>
                )}
                <DescriptionOutlined className={classes.descriptionIcon} fontSize="large" />
              </div>
            </ImageMetaData>
          </div>
        ))}
      </div>
    </>
  );
};

export default withSnackbar(EDRList);
